import React,{useEffect,useState} from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Alert } from '@mui/material/';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering


function Autorize({axiosError,sessionExpirer,ruleAcces}) {
  
    
    const InValide = <Alert severity="error">Aucune données retournées par le serveur. <br />1 - Veuillez modifier votre recherche. <br />2 - Vous n'avez peut-être pas accès à cette zone.</Alert>;
    const PasAcccesMsg = <Alert severity="error">Vous n'avez pas accès à cette zone.</Alert>;
   // const [expirer,setExpirer] = useState(true);
    const myMessage = <Alert severity='error'>Votre session est expirée, veuillez vous reconnecter.</Alert>;
    
    

    useEffect(() => {
                 
       
    },[axiosError,sessionExpirer,ruleAcces]);


    function Message(){
      
        if(sessionExpirer === true) 
        {
            console.log("Autorize Votre session est expiré... Token expirer");
            //callBackAutoriser(false);
            return myMessage;
        } 
       // else
        //  console.log("Votre session est ACTIVE... Token VALIDE");
                 
        if(ruleAcces === false) {

            console.log("Autorize pas Acces error");
            return PasAcccesMsg;

        }
        
        if(axiosError === true) {

            console.log("Autorize axiosError error");
            return InValide;

        }

       
             
        return "";

    }


        return (
                <div> {Message()} </div>
          
        )
       
    
}

export default Autorize;